import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=5efd8bae&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=5efd8bae&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd8bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efd8bae')) {
      api.createRecord('5efd8bae', component.options)
    } else {
      api.reload('5efd8bae', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=5efd8bae&scoped=true", function () {
      api.rerender('5efd8bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/subSidebar/SidebarItem.vue"
export default component.exports